import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import comittyLogo from "../../components/logos/logo.svg";
import backButton from "../../images/icons/back.png";
import "./signup.scss";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import { useDispatch } from "react-redux";
import userAction from "../../redux/users/action";
import { db } from "../../firebase";
import { doc, setDoc, collection, query, where, getDocs } from "firebase/firestore";
import FormField from "../../components/formField/FormField.jsx";
import LanguageSwitcher from "../../components/LanguageSwitcher.jsx";
import { Loader2 } from "../../helper/loader.js";
import Aurora from "../../components/aurora/Aurora.jsx";
import DashboardAppSelectorModal from "../../components/dashboardAppSelector/DashboardAppSelectorModal.jsx";

async function signUpUser(User) {
  let success = true;
  let error = "";
  let data = {};

  const auth = getAuth();
  await createUserWithEmailAndPassword(auth, User.email, User.password)
    .then(async (user) => {
      const cashierEmail = await getAllOfCollectionWhereInArray(
        "Organizations",
        "cashierEmail",
        User.email,
      );
      const adminEmail = await getAllOfCollectionWhereInArray(
        "Organizations",
        "adminEmail",
        User.email,
      );
      const stewardEmail = await getAllOfCollectionWhereInArray(
        "Organizations",
        "stewardEmail",
        User.email,
      );
      if (cashierEmail.length > 0) {
        for (let index = 0; index < cashierEmail.length; index++) {
          let element = cashierEmail[index];
          element?.cashierUid.push(user.user.uid);
          let temp = [...element?.cashierEmail];
          temp = temp.filter((item) => {
            return item !== User.email;
          });
          await saveData("Organizations", element?.id, {
            ...element,
            cashierEmail: temp,
          });
        }
      }
      if (stewardEmail.length > 0) {
        for (let index = 0; index < stewardEmail.length; index++) {
          let element = stewardEmail[index];
          if (element?.stewardUid) element?.stewardUid.push(user.user.uid);
          else element.stewardUid = [user.user.uid];
          let temp = [...element?.stewardEmail];
          temp = temp.filter((item) => {
            return item !== User.email;
          });
          await saveData("Organizations", element?.id, {
            ...element,
            stewardEmail: temp,
          });
        }
      }
      if (adminEmail?.length > 0) {
        for (let index = 0; index < adminEmail.length; index++) {
          let element = adminEmail[index];
          element?.adminUid.push(user.user.uid);
          let temp = [...element.adminEmail];
          temp = temp.filter((item) => {
            return item !== User.email;
          });
          await saveData("Organizations", element?.id, {
            ...element,
            adminEmail: temp,
          });
        }
      }

      await saveData("Store", user.user.uid, {
        uid: user.user.uid,
        email: User.email,
        username: User.username,
        type: "admin",
        activeOrg: "",
        createAt: new Date().getTime().toString(),
        country: User.country,
        postalCode: User.postalCode,
      });
      data = {
        uid: user.user.uid,
        email: User.email,
        username: User.username,
        type: "admin",
        activeOrg: "",
        createAt: new Date().getTime().toString(),
        country: User.country,
        postalCode: User.postalCode,
      };
    })
    .catch(function (err) {
      success = false;
      error = err;
    });
  return { error, success, data };
}

async function saveData(collectionName, docId, jsonObject) {
  let success = false;
  await setDoc(doc(db, collectionName, docId), jsonObject, { merge: true })
    .then(() => {
      success = true;
    })
    .catch(function (error) {
      console.error("Error writing document: ", error);
      success = false;
    });
  return success;
}

async function getAllOfCollectionWhereInArray(collectionName, key, value) {
  let data = [];
  const q = query(collection(db, collectionName), where(key, "array-contains", value));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    if (doc.exists()) {
      data.push(doc.data());
    } else {
      console.log("No document found!");
    }
  });
  return data;
}

function SignUp() {
  const { t } = useTranslation("signup");
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const { i18n } = useTranslation();
  const { setUser } = userAction;
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [country, setCountry] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showWelcomeOverlay, setShowWelcomeOverlay] = useState(false);
  const [showAppOnboarding, setShowAppOnboarding] = useState(false);
  const [createdUser, setCreatedUser] = useState(null);
  const [isSavingApps, setIsSavingApps] = useState(false);
  const welcomeTimeoutRef = useRef(null);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRepeatPasswordVisibility = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    setErrors({});
    setIsLoading(true);

    if (formData.password !== formData.repeatPassword) {
      errors.password = t("passwordMismatch");
      errors.repeatPassword = t("passwordMismatch");
    } else if (formData.password.length < 6) {
      errors.password = t("passwordLength");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = t("invalidEmail");
    }

    if (!country || !country.name) {
      errors.country = t("invalidCountry");
    }

    if (Object.keys(errors).length === 0) {
      try {
        const data = {
          email: formData.email.toLowerCase(),
          password: formData.password,
          username: formData.username,
          postalCode: formData.postalCode,
          lang: i18n.language,
          country: country,
        };

        const resp = await signUpUser(data);

        if (resp.success) {
          setIsLoading(false);
          setCreatedUser(resp.data);
          setShowAppOnboarding(true);
          return;
        } else {
          if (resp.error.code === "auth/email-already-in-use") errors.email = t("emailInUse");
        }
      } catch (error) {
        console.error(error);
      }
    }

    setIsLoading(false);
    setErrors({ ...errors });
  };

  const handleSaveDashboardApps = async (dashboardApps) => {
    if (!createdUser?.uid) return;

    setIsSavingApps(true);
    const nextUser = {
      ...createdUser,
      dashboardApps,
    };

    const saved = await saveData("Store", createdUser.uid, { dashboardApps });
    setIsSavingApps(false);

    if (saved) {
      dispatch(setUser(nextUser));
      setShowAppOnboarding(false);
      setShowWelcomeOverlay(true);
      welcomeTimeoutRef.current = setTimeout(() => {
        navigate("/dashboard/overview");
      }, 1600);
    }
  };

  useEffect(() => {
    return () => {
      if (welcomeTimeoutRef.current) {
        clearTimeout(welcomeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="signupPage">
      <Aurora />

      <div className="signupInner">
        <div className="commityImg">
          <img className="img-fluid" src={comittyLogo} alt={t("altText")} />
        </div>
        <div className="signupForm">
          <div className="titleContainer">
            <button className="buttonBackContainer" onClick={() => navigate("/login")}>
              <img src={backButton} alt="Back" />
              <p>{t("return")}</p>
            </button>
            <h3>{t("welcome")}</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <FormField
              name="username"
              value={formData.username}
              onChange={(value) => handleChange("username", value)}
              error={errors?.username}
              label={t("username")}
            />
            <FormField
              name="email"
              value={formData.email}
              onChange={(value) => handleChange("email", value)}
              error={errors?.email}
              label={t("email")}
            />
            <FormField
              name="postalCode"
              value={formData.postalCode}
              onChange={(value) => handleChange("postalCode", value)}
              error={errors?.postalCode}
              label={t("postalCode")}
            />
            <FormField
              name="country"
              value={country}
              onChange={setCountry}
              error={errors?.country}
              label={t("country")}
              type="country"
            />
            <FormField
              name="password"
              value={formData.password}
              onChange={(value) => handleChange("password", value)}
              error={errors?.password}
              label={t("password")}
              type="password"
              showPassword={showPassword}
              togglePassword={togglePasswordVisibility}
            />
            <FormField
              name="repeatPassword"
              value={formData.repeatPassword}
              onChange={(value) => handleChange("repeatPassword", value)}
              error={errors?.repeatPassword}
              label={t("repeatPassword")}
              type="password"
              showPassword={showRepeatPassword}
              togglePassword={toggleRepeatPasswordVisibility}
            />
            <button className="signupBtn" type="submit">
              {t("signUp")}
            </button>
          </form>
          <div className="languageSwitcherContainer">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
      {showWelcomeOverlay && (
        <div className="signupWelcomeOverlay" role="status" aria-live="polite">
          <div className="signupWelcomeOverlayInner">
            <p className="welcomeEyebrow">{t("welcomeBackEyebrow")}</p>
            <h2>{t("welcomeBackTitle")}</h2>
            <p className="welcomeSubtitle">{t("welcomeBackSubtitle")}</p>
          </div>
        </div>
      )}
      <DashboardAppSelectorModal
        isOpen={showAppOnboarding}
        mode="onboarding"
        isSaving={isSavingApps}
        onSave={handleSaveDashboardApps}
      />
      {isLoading && <Loader2 />}
    </div>
  );
}

export default SignUp;
